import angular from 'angular';

import FeatureFlagsDirective from './feature-flags.directive';

const FeatureFlagsModule = angular
    .module('control-room.commons.basic.directives.feature-flags', [])
    .directive('crFeatureFlags', FeatureFlagsDirective.directiveFactory);

export default FeatureFlagsModule;
